import { render } from "./videoListItem.vue?vue&type=template&id=5b25011f&scoped=true&ts=true"
import script from "./videoListItem.vue?vue&type=script&lang=ts"
export * from "./videoListItem.vue?vue&type=script&lang=ts"

import "./videoListItem.vue?vue&type=style&index=0&id=5b25011f&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25011f"]])

export default __exports__